import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { ListItemButton } from '@mui/material';
import { Colors } from 'styles/variables/colors';
import { Variables } from 'styles/variables/variables';

export const Name = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
`;

export const Option = styled(ListItemButton)`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    display: flex;
    gap: 0.6rem;
    align-items: center;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MatchingData = styled.ul<{
    clientView?: boolean;
    mobile?: boolean;
    onboarding?: boolean;
}>`
    background: ${Colors.white};
    padding: 0.5rem 0rem 0.5rem 0rem;
    min-width: ${({ mobile, clientView, onboarding }) =>
        mobile || onboarding ? '100%' : clientView ? '220px' : '289px'};
    max-width: ${({ mobile, clientView, onboarding }) =>
        mobile || onboarding ? '100%' : clientView ? '220px' : '289px'};
    /* height: fit-content; */
    z-index: 1;
    display: flex;
    flex-direction: column;
    border: ${(props) => (props.mobile ? '1px solid #8353E2FF' : '1px solid #00a9c0ff')};
    border-radius: 4px;
    margin-top: 0.3rem;
    /* max-height: 275px;
    overflow-y: auto; */
    overflow: hidden;
`;

export const ScrollableMatches = styled.ul<{ mobile?: boolean }>`
    border: ${(props) => (props.mobile ? '1px solid #8353E2FF' : '1px solid #00a9c0ff')};
    border-radius: 8px;
    box-shadow: 0px 10px 20px -15px #171a1f;
    padding-top: 0.3rem;
    max-height: ${(props) => (props.mobile ? '200px' : '250px')};
    overflow-y: auto;
    background: ${Colors.white};
`;

type MenuItemProps = {
    margin?: string;
    marginRight?: string;
};

export const ScrollableMatch = styled.li<MenuItemProps>`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })};
    margin-left: ${(props) => (props.margin ? props.margin : '')};
    min-height: auto;
    text-decoration: none;
    padding-bottom: 0.2rem;
    padding-top: 0.2rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
    line-height: 1.2;
    white-space: nowrap;
    cursor: pointer;
    :hover {
        background-color: #f5f5f5ff;
    }
`;

export const SearchContainer = styled.div<{
    clientView?: boolean;
    mobile?: boolean;
    onboarding?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    min-width: ${({ mobile, clientView, onboarding }) =>
        mobile || onboarding ? '100%' : clientView ? '220px' : '289px'};
    max-width: ${({ mobile, clientView, onboarding }) =>
        mobile || onboarding ? '100%' : clientView ? '220px' : '289px'};

    ${({ clientView }) =>
        clientView
            ? `
                /* Modal-aligned look: rounded pill, purple-tinted border,
                 * subtle elevation, and a soft purple focus ring that mirrors
                 * the onboarding / assign / reminder modal inputs. */
                height: 40px;
                padding: 8px 14px;
                gap: 8px;
                border: 1px solid rgba(148, 163, 184, 0.28);
                border-radius: 14px;
                background: rgba(255, 255, 255, 0.9);
                box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
                color: #111827;
                transition:
                    transform 0.2s ease,
                    border-color 0.2s ease,
                    box-shadow 0.2s ease,
                    background 0.2s ease;

                svg {
                    flex-shrink: 0;
                    color: #6d41d8;
                }

                svg path {
                    fill: #6d41d8;
                }

                &:hover {
                    transform: translateY(-1px);
                    border-color: rgba(131, 83, 226, 0.32);
                    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
                }

                &:focus-within {
                    border-color: #8353e2;
                    background: #ffffff;
                    box-shadow:
                        0 0 0 3px rgba(131, 83, 226, 0.16),
                        0 8px 18px rgba(131, 83, 226, 0.14);
                }
            `
            : `
                height: 36px;
                padding: 9px 12px;
                border: 1px solid #9095a0ff;
                border-radius: 4px;
            `}
`;

export const RelativeContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const AbsoluteContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
`;

export const SearchIconContainer = styled.div`
    fill: ${Colors.darkGray};
    width: 16px;
    height: 16px;
    color: ${Colors.white};
`;

export const SearchInput = styled.input<{ clientView?: boolean }>`
    line-height: 18px;
    width: 90%;
    outline: none;
    height: 30px;
    font-size: 15px;
    font-family: ${Variables.montserrat};
    font-weight: ${({ clientView }) => (clientView ? '600' : '400')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    -webkit-tap-highlight-color: transparent;

    &:focus,
    &:focus-visible {
        outline: none;
        box-shadow: none;
    }

    ${({ clientView }) =>
        clientView
            ? `
                /* Inside the modal-aligned SearchContainer the input blends
                 * into the rounded pill — no inner border, transparent
                 * background, and dark slate text/placeholder so the client
                 * name reads as a label-style cue. */
                flex: 1 1 auto;
                min-width: 0;
                width: 100%;
                padding: 0;
                border: 0;
                background: transparent;
                color: #111827;

                ::placeholder {
                    color: #111827;
                    opacity: 1;
                }
                :focus::placeholder {
                    color: #cbd5f5;
                }
            `
            : `
                :focus::placeholder {
                    color: ${Colors.white};
                }
            `}
`;
